import createReactComponent from '../createReactComponent';
export default createReactComponent('reserved-line', 'IconReservedLine', [
  ['path', { d: 'M9 20h6', key: 'svg-0' }],
  ['path', { d: 'M12 14v6', key: 'svg-1' }],
  [
    'path',
    {
      d: 'M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z',
      key: 'svg-2',
    },
  ],
  ['path', { d: 'M9 9h6', key: 'svg-3' }],
]);
